import {
  GroupeInfo,
  GroupeInfoServer,
  GroupsListServer,
  GroupsList,
} from '../store/types';

import { GroupeUser, GroupeUserServer } from './../store/types';

export const adapteGroupeUserInfo = ({ group_id, next_month_paid, current_month_paid, birth_date, ...res }: GroupeUserServer): GroupeUser => ({
  ...res,
  groupId: group_id,
  currentMonthPaid: current_month_paid,
  nextMonthPaid: next_month_paid,
  birthDate: birth_date
});

export const adapteGroupeInfo = ({ coach_id, coach_name, price_individual, price, users, ...res }: GroupeInfoServer): GroupeInfo => ({
  ...res,
  coachId: coach_id,
  coachName: coach_name,
  priceIndividual: Number(price_individual),
  price: Number(price),
  users: users.map((user) => adapteGroupeUserInfo(user))
});

export const adapteGroupsList = (res: GroupsListServer): GroupsList => ({
  count: res.count,
  items: res.items.map(adapteGroupeInfo).sort((a, b) => a.id - b.id)
});
